import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=66f2583e&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=66f2583e&prod&scoped=true&lang=css"
import style1 from "./SearchResult.vue?vue&type=style&index=1&id=66f2583e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f2583e",
  null
  
)

export default component.exports